export const getTempAnnotations = (state) => {
    const tempAnnotations = state.tempAnnotations;
    return tempAnnotations.map((annotation) => {
        const { isRemovable, ...rest } = annotation;

        return rest;
    });
};
